<template>
    <div class="af3-shortcodes-single-gallery-component">



        <div class="gallery" v-if="options.floor_plans_loop_show_gallery && filtered_floorplan_gallery.length > 1">
            <div class="af3-floor-plan-gallery">
                <div class="swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(image, index) in filtered_floorplan_gallery" :key="index">
                        <div class="image-container">
                            <img :src="image" alt="Floor Plan Image" class="floor-plan-image" @click="showLightbox(index)" />
                            <button class="zoom-button" @click="showLightbox(index)" v-if="options.single_floor_plan_show_zoom_button">
                                <span class="zoom-icon">+</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="options.floor_plans_loop_show_gallery && filtered_floorplan_gallery.length > 1" class="swiper-button-prev">
                    <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23.277" height="20.619" viewBox="0 0 23.277 20.619">
                        <defs>
                            <clipPath id="clip-path">
                            <rect id="Rectangle_455" data-name="Rectangle 455" width="23.277" height="20.619" transform="translate(0 0)" fill="none"/>
                            </clipPath>
                        </defs>
                        <g id="Group_5292" data-name="Group 5292" transform="translate(0 0)">
                            <g id="Group_5291" data-name="Group 5291" clip-path="url(#clip-path)">
                            <path id="Path_46212" data-name="Path 46212" d="M12.968,20.619a1,1,0,0,1-.707-1.707l7.6-7.6H1a1,1,0,0,1,0-2H19.864l-7.6-7.6A1,1,0,0,1,13.675.293L22.985,9.6l.022.024h0s0,0,0,0h0a1,1,0,0,1,.267.68v0a1,1,0,0,1-.265.675h0l0,0c-.009.008-.017.017-.025.025l-9.31,9.31a1,1,0,0,1-.707.293" fill="#111e1a"/>
                            </g>
                        </g>
                    </svg>
                </div>
                <div v-if="options.floor_plans_loop_show_gallery && filtered_floorplan_gallery.length > 1" class="swiper-button-next">
                    <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23.277" height="20.619" viewBox="0 0 23.277 20.619">
                        <defs>
                            <clipPath id="clip-path">
                            <rect id="Rectangle_455" data-name="Rectangle 455" width="23.277" height="20.619" transform="translate(0 0)" fill="none"/>
                            </clipPath>
                        </defs>
                        <g id="Group_5292" data-name="Group 5292" transform="translate(0 0)">
                            <g id="Group_5291" data-name="Group 5291" clip-path="url(#clip-path)">
                            <path id="Path_46212" data-name="Path 46212" d="M12.968,20.619a1,1,0,0,1-.707-1.707l7.6-7.6H1a1,1,0,0,1,0-2H19.864l-7.6-7.6A1,1,0,0,1,13.675.293L22.985,9.6l.022.024h0s0,0,0,0h0a1,1,0,0,1,.267.68v0a1,1,0,0,1-.265.675h0l0,0c-.009.008-.017.017-.025.025l-9.31,9.31a1,1,0,0,1-.707.293" fill="#111e1a"/>
                            </g>
                        </g>
                    </svg>
                </div>
                </div>
            </div>
            <vue-easy-lightbox
                v-if="options.single_floor_plan_show_zoom_button"
                :visible="visible"
                :imgs="filtered_floorplan_gallery"
                :index="currentIndex"
                @hide="handleHide"
            />
        </div>

            
        <div v-else>

            <div class="image-container">
                <img class="af3-shortcodes-single-gallery-component-image" :src="floor_plan.image.url" :alt="floor_plan.image.alt" />
                <button class="zoom-button" @click="showLightbox" v-if="options.single_floor_plan_show_zoom_button">
                    <span class="zoom-icon">+</span>
                </button>
            </div>
            <vue-easy-lightbox
                v-if="options.single_floor_plan_show_zoom_button"
                :visible="visible"
                :imgs="[floor_plan.image.url]"
                :index="0"
                @hide="handleHide"
            />
        </div>



    </div>
</template>
  
<script>
import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default defineComponent({
    components: { 
        VueEasyLightbox
    },
   
    props: {
        options: {
            type: Object,
            required: true
        },
        floor_plan: {
            type: Object,
            required: true
        }
    },

    setup(props) {
        const visible = ref(false);
        const currentIndex = ref(0);

        let swiper = null;
        let filtered_floorplan_gallery = ref(props.floor_plan.floorplan_gallery);

        onMounted(() => {
            if(filtered_floorplan_gallery.value.length > 1){
                swiper = new Swiper('.swiper', {
                    modules: [Navigation],
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    observer: true,
                    observeParents: true,
                    updateOnImagesReady: true
                });
            }
        });

        const showLightbox = (index) => {
            currentIndex.value = index;
            visible.value = true;
        };

        const handleHide = () => {
            visible.value = false;
        };
         
        return {
            filtered_floorplan_gallery,
            visible,
            currentIndex,
            showLightbox,
            handleHide
        };
    }
});
</script>